// Copyright 2022 Huawei Cloud Computing Technology Co., Ltd.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import {OpusDecoder} from "../3rd/opus/opus";

const decoder = new OpusDecoder(48000, 2);

self.addEventListener('message', evt => {
    const message = evt.data;
    switch (message.type) {
    case 'decode': {
        let pcmData = decoder.decode_float(message.data);
        self.postMessage({
            type: 'decodeResult',
            data: pcmData.buffer
        }, [pcmData.buffer]);
        break;
    };

    default:
        // do nothing
    }
});

export default function () {}
